import {
  SET_TAG_OPTIONS,
  GET_TAG_OPTIONS,
  TagOptions,
  GET_TAG_LOADING,
  SET_TAG_LOADING,
} from "./types";

export const getTagOptions = () => ({
  type: GET_TAG_OPTIONS,
});

export const setTagOptions = (payload: TagOptions) => {
  return {
    type: SET_TAG_OPTIONS,
    payload,
  };
};

export const getTagLoading = () => ({
  type: GET_TAG_LOADING,
});

export const setTagLoading = (payload: boolean) => {
  return {
    type: SET_TAG_LOADING,
    payload,
  };
};
